import { render, staticRenderFns } from "./manage_phone.vue?vue&type=template&id=6b8ee5b5&scoped=true"
import script from "./manage_phone.vue?vue&type=script&lang=js"
export * from "./manage_phone.vue?vue&type=script&lang=js"
import style0 from "./manage_phone.vue?vue&type=style&index=0&id=6b8ee5b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ee5b5",
  null
  
)

export default component.exports